import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PregledLotoviService {

  constructor(private _http: HttpClient) { }

  prometRobe(a: any) {
    return this._http.post(AppConfig.ipAddress + 'promet_robe', a)
      .pipe(map((res: any) => res));
  }

  dohvatiSveProizvode(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_sve_artikle', a)
      .pipe(map((res: any) => res));
  }

  dohvati_stavke_prometRobe(a: any) {
    return this._http.post(AppConfig.ipAddress + 'dohvati_stavke_promet_robe', a)
      .pipe(map((res: any) => res));
  }

  obrisi_stavku_prometRobe(a: any) {
    return this._http.post(AppConfig.ipAddress + 'obrisi_stavku_promet_robe', a)
      .pipe(map((res: any) => res));
  }
}
